import { render } from "./peringatan-list.vue?vue&type=template&id=45632176"
import script from "./peringatan-list.vue?vue&type=script&lang=js"
export * from "./peringatan-list.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__